import React from 'react'
import exit from '../../assets/images/hboprop/exit_button.png'
import exitBlue from '../../assets/images/hboprop/exit_button_bl.png'

class ButtonExit extends React.Component {
  state = {
    pressed: false,
  }

  render = () => (
    <div
      className='exit-button'
      onTouchStart={() => {this.setState({ pressed: true })}}
      onTouchEnd={() => {this.setState({ pressed: false })}}
      style={this.state.pressed ? exitButtonContainerScaled : exitButtonContainer}>
      <img
        style={exitButton}
        src={(this.props.color == 'blue' ? exitBlue : exit)}
        alt="Exit"
        onClick={this.props.onClick}
      />
    </div>
  )
}

const exitButtonContainer = {
  position: 'absolute',
  right: '0px',
  top: '2px',
  opacity: 1,
  transition: 'all 150ms ease-in-out'
}
const exitButtonContainerScaled = {
  ...exitButtonContainer,
  transform: 'scale(.8)',
  opacity: .4,
}
const exitButton = {
  height: 55,
  width: 55,
}


export default ButtonExit
